import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=55ee83e6&"
import script from "./RulesTable.vue?vue&type=script&lang=js&"
export * from "./RulesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports